<template>
	<el-dialog class="phoneDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				{{!orderData.pj_status ? '' : '查看'}}评价
			</div>
		</div>
		<div class="dislogConent">
			<el-form ref="phoneRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="是否满意：" prop="cost">
					<div class="menu" v-if="!orderData.pj_status">
						<div class="menuItem" :class="selIndex == 1 ? 'menuItemSel' : 'menuItemNor'"
							@click="selIndex = 1">满意</div>
						<div class="menuItem" :class="selIndex == 2 ? 'menuItemSel' : 'menuItemNor'"
							@click="selIndex = 2">一般</div>
						<div class="menuItem" :class="selIndex == 3 ? 'menuItemSel' : 'menuItemNor'"
							@click="selIndex = 3">不满意</div>
					</div>
					<div class="menu" v-else>
						<div class="menuItem" :class="selIndex == 1 ? 'menuItemSel' : 'menuItemNor'"
							@click="selIndex = 1">{{orderData.pj_status}}</div>
					</div>
				</el-form-item>
				<el-form-item label="图文评价：" prop="content">
					<div class="replyContent" v-if="!orderData.pj_status">
						<textarea v-model="ruleForm.content" maxlength="200" placeholder="请输入备注内容（选填）"></textarea>
						<div class="textNum">
							<span>{{ruleForm.content ? ruleForm.content.length : 0}}</span>/200
						</div>
					</div>
					<div class="replyContentStr" v-else>
						{{orderData.pj_content}}
					</div>
				</el-form-item>
				<el-form-item label="上传图片：" prop="qy_num">
					<div class="imgList" v-if="!orderData.pj_status">
						<div class="imgItem" v-for="(item,index) in imgList" :key="index">
							<img class="imgItemImg" :src="item" />
							<img class="delete" @click="imgList.splice(index, 1)" src="../assets/Feedback/delete.png" />
						</div>
						<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
							<img class="addImg" src="../assets/Feedback/addImg.png" />
							上传图片
						</div>
					</div>
					<div class="imgList" v-if="orderData.pj_img">
						<div class="imgItem" v-for="(item,index) in orderData.pj_img.split(',')" :key="index">
							<el-image class="imgItemImg" fit="cover" :src="item" :key="item"
								:preview-src-list="orderData.pj_img.split(',')">
							</el-image>
						</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox" v-if="!orderData.pj_status">
				<el-button class="submit" type="primary" size="medium"
					@click="submitPhoneForm('phoneRuleForm')">提交</el-button>
			</div>
			<div class="menuBox" v-else>
				<el-button class="submit" type="primary" size="medium" @click="handleClose">好的</el-button>
				<el-button class="delete" type="primary" size="medium" @click="handleDelete">删除</el-button>
			</div>
		</div>
		<el-upload ref="upload" style="font-size: 0;" name="image"
			action="https://ht.daiyuart.com/api.php/set/Other/upload_img" :show-file-list="false" :limit="6" multiple
			:on-success="handlePhotoSuccess">
		</el-upload>
	</el-dialog>
</template>

<script>
	export default {
		name: 'EvaluateDialog',
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			orderData: {
				type: Object,
				default: () => {},
			}
		},
		data() {
			return {
				selIndex: 1,
				imgList: [],
				ruleForm: {
					content: '',
				},
				rules: {},
			}
		},
		methods: {
			handleClose() {
				this.ruleForm = {
					content: ''
				}
				this.$emit('close')
			},
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response, file) {
				console.log(file)
				this.imgList.push(response.data)
			},
			handleDelete() {
				this.$api.post('/Hua/del_dz_order_evaluate', {
					id: this.orderData.id,
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.$emit('update')
					} else {
						this.$message.error(res.msg)
					}
					this.handleClose()
				}).catch(err => {
					console.log(err);
				})
			},
			submitPhoneForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/dz_order_evaluate', {
							id: this.orderData.id,
							pj_img: this.imgList.join(','),
							pj_content: this.ruleForm.content,
							pj_status: this.selIndex == 1 ? '满意' : this.selIndex == 2 ? '一般' : '不满意'
						}).then(res => {
							if (res.code == 1) {
								this.$message.success(res.msg)
								this.$emit('update')
							} else {
								this.$message.error(res.msg)
							}
							this.handleClose()
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.menu {
		display: flex;
		align-items: center;

		.menuItem {
			margin-right: .16rem;
			width: .76rem;
			height: .4rem;
			font-size: .14rem;
			border-radius: .04rem;
			line-height: .4rem;
			text-align: center;
			cursor: pointer;
		}

		.menuItemNor {
			font-weight: 400;
			color: #000000;
			background: rgba(226, 147, 88, .3);
		}

		.menuItemSel {
			font-weight: 500;
			color: #252525;
			background: #E29358;
		}
	}

	.replyContentStr {
		width: 6rem;
		font-weight: 400;
		font-size: .14rem;
		color: #252525;
		line-height: .2rem;
	}

	.replyContent {
		width: 6rem;
		height: 1.6rem;
		background: #FFFFFF;
		border-radius: .04rem;
		border: .01rem solid #EFD8B8;
		position: relative;

		.textNum {
			position: absolute;
			right: .12rem;
			bottom: .12rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #999999;
			line-height: .2rem;

			span {
				color: #252525;
			}
		}

		textarea {
			width: 100%;
			height: 100%;
			border: none;
			padding: .12rem .12rem;
			font-weight: 400;
			font-size: .14rem;
		}
	}

	.imgList {
		display: flex;
		flex-wrap: wrap;

		.imgItem {
			margin-right: .16rem;
			display: flex;
			width: .86rem;
			height: .86rem;
			border-radius: .04rem;
			overflow: hidden;
			position: relative;

			.delete {
				position: absolute;
				top: .05rem;
				right: .05rem;
				width: .14rem;
				height: .14rem;
				cursor: pointer;
			}

			.imgItemImg {
				width: .86rem;
				height: .86rem;
				object-fit: cover;
			}
		}

		.addImgBox {
			width: .86rem;
			height: .86rem;
			border-radius: .04rem;
			background: #FFFFFF;
			border: 1px solid #EFD8B8;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-weight: 400;
			font-size: .12rem;
			line-height: .16rem;
			color: #999999;
			cursor: pointer;

			.addImg {
				margin-bottom: .08rem;
				width: .27rem;
				height: .23rem;
			}
		}
	}

	.phoneDialog {
		::v-deep .el-dialog {
			width: 7.4rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(2),
					&-item:nth-child(3) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: .9rem;
							padding: 0 .12rem 0 0;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {
							line-height: .52rem;
							font-size: .14rem;

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;
					padding-top: .32rem;

					.submit {
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}

					.delete {
						width: 1.3rem;
						height: .36rem;
						background: #FFFFFF;
						border-radius: .04rem;
						border: .01rem solid #E29358;
						font-weight: 400;
						padding: 0 0;
						font-size: .14rem;
						color: #E29358;
						text-align: center;
						line-height: .36rem;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>